/**
 * Toast Message Formatters for Order Placement
 * Provides standardized success/error messages across the app
 */

/**
 * Format order placement success message
 * @param {string} side - BUY or SELL
 * @param {number} quantity - Order quantity
 * @param {string} symbol - Trading symbol
 * @returns {string} Formatted success message
 */
export const formatOrderSuccess = (side, quantity, symbol) => {
  return `${side} order placed: ${quantity} x ${symbol}`;
};

/**
 * Format order placement error message
 * @param {Error} error - Error object from API
 * @returns {string} Formatted error message
 */
export const formatOrderError = (error) => {
  if (!error) return 'Order placement failed';
  if (typeof error === 'string') return error;
  return error.message || 'Order placement failed';
};

/**
 * Format lot size validation warning message
 * @param {number} quantity - Entered quantity
 * @param {number} lotSize - Required lot size
 * @returns {string} Formatted warning message
 */
export const formatLotSizeWarning = (quantity, lotSize) => {
  return `Quantity ${quantity} is not a multiple of lot size ${lotSize}`;
};
